import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const Container = styled(Stack)<{ $bg: string }>`
    width: 100%;
    background: ${({ $bg }) => $bg};
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    height: 100%;
    overflow: hidden;
`;

export const Center = styled(Stack)`
    width: min(88%, 520px);
    gap: 2px;
    align-items: center;
`;

export const Block = styled(Stack)<{ $bg: string; $text: string }>`
    background: ${({ $bg }) => $bg};
    color: ${({ $text }) => $text};
    border-radius: 4px;
    width: 130px;
    padding: 2px 12px;
    text-align: center;
    justify-content: center;
    align-items: center;
    min-height: 35px;

    @media (max-width: 1350px) {
        width: 114px;
    }
`;

export const Title = styled.div`
    ${setFontVariant("listItem3", carbon[0])};
`;

export const Value = styled.div`
    ${setFontVariant("h4", carbon[0])};
    text-wrap: nowrap;
`;

export const TopicName = styled.div`
    ${setFontVariant("tab", carbon[0])};
`;
